import throttle from 'OK/utils/throttle';

var toolbarHeight = OK.topPanelHeight();

var TOP_PADDING = toolbarHeight + 12, // 12 - "островной" отступ
    BOTTOM_PADDING = 12;

var stickyBannerContainers = {};
var windowEventListenerHandler;

/**
 * Залипающий контейнер для баннеров
 */
class StickyBannerContainer {
    constructor(htmlElem) {
        this.hookEl = htmlElem;
        if (htmlElem && htmlElem.hasChildNodes()) {
            var el = htmlElem.getElementsByClassName('banner-sticky-container');
            this.bannerContainer = el.length > 0 ? el[0] : htmlElem.firstElementChild;
        }
        this.currBannerContainerMinHeight = 0;
        this.doReflow();
    }

    doReflow() {
        if (!this.bannerContainer) {
            return;
        }
        var bannerContainerHeight = this.bannerContainer.clientHeight;

        // change banner min-height only if banner change content height - on scroll event
        if (this.currBannerContainerMinHeight !== bannerContainerHeight) {
            this.hookEl.style.minHeight = bannerContainerHeight + "px";
            this.currBannerContainerMinHeight = bannerContainerHeight;
        }

        var bannerWrapperCoords = this.hookEl.getBoundingClientRect();
        var bannerWrapperTop = bannerWrapperCoords.top;

        if (bannerWrapperTop <= TOP_PADDING) {
            var footer = document.getElementById('footer');
            var footerCoords = footer.getBoundingClientRect();
            this.bannerContainer.style.position = "fixed";
            if (bannerContainerHeight + TOP_PADDING + BOTTOM_PADDING < footerCoords.top) {
                // залипаем сверху
                this.bannerContainer.style.top = TOP_PADDING + "px";
                this.bannerContainer.style.bottom = "auto";
            } else {
                // упёрлись в футер и залипли снизу
                this.bannerContainer.style.top = "auto";
                this.bannerContainer.style.bottom = document.documentElement.clientHeight - footerCoords.top + "px";
            }
        } else {
            this.bannerContainer.style.position = "static";
        }
    }
}


function activate(htmlElem) {
    if (!htmlElem || !htmlElem.id) {
        return;
    }
    stickyBannerContainers[htmlElem.id] = new StickyBannerContainer(htmlElem);
    if (!windowEventListenerHandler) {
        windowEventListenerHandler = throttle(10, doReflow);
        window.addEventListener('scroll', windowEventListenerHandler, false);
        window.addEventListener('resize', windowEventListenerHandler, false);
    }
}

function doReflow() {
    for (var id in stickyBannerContainers) {
        if (!stickyBannerContainers.hasOwnProperty(id)) {
            continue;
        }
        var container = stickyBannerContainers[id];
        container.doReflow();
    }
}

function deactivate(htmlElem) {
    if (!htmlElem || !htmlElem.id) {
        return;
    }
    delete stickyBannerContainers[htmlElem.id];
    if (Object.keys(stickyBannerContainers).length === 0) {
        window.removeEventListener('scroll', windowEventListenerHandler, false);
        window.removeEventListener('resize', windowEventListenerHandler, false);
        windowEventListenerHandler = null;
    }
}

export default { activate, deactivate };

export { activate, deactivate };
